export default "__VITE_PUBLIC_ASSET__5e2b392f__"